import { useEffect } from "react";
import { useLocation } from "react-router";
import { configureZoomSdk } from "../../utilities/zoomSdkSetup";
import { isZoomEmbeddedApp } from "../../utilities/postLoginRoute";

const ZoomSdkConfigurator = () => {
  const location = useLocation();

  useEffect(() => {
    if (!isZoomEmbeddedApp()) {
      return;
    }

    configureZoomSdk().catch((error) => {
      console.error("Zoom SDK re-config failed after navigation:", error);
    });
  }, [location.pathname, location.search]);

  return null;
};

export default ZoomSdkConfigurator;
